import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Spinner from "../common/spinner";
import { ToastContainer, toast } from "react-toastify";
import "./bundleTransport.scss";
import * as service from "./bundleTransportServices";
import {
  timestampToDateYearAndTime,
  log,
  getMapIdBasedonEnvironment,
} from "../../helper/helper";
import ridingImage from "../../assets/riding.png";
import walkingImage from "../../assets/walking.png";
import cyclingImage from "../../assets/cycling.png";
import drivingImage from "../../assets/driving.png";
import origin from "../../assets/origin.png";
import destination from "../../assets/destination.png";
import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import decodePolyline from "decode-google-map-polyline";
import BundleParcelImageComponents from "./BundleParcelImageComponents";

function BundleTransport(props) {
  const [transports, setTransports] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isHidden, setBtnHidden] = useState(false);
  const [cursorTransportId, setCursorTransportId] = useState("");

  const [selectedColors, setSelectedColors] = useState({});
  const [positions, setPositions] = useState([]);
  const [map, setMap] = useState(null);
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        return props.history.replace("/login");
      }
      adminGetAllActiveTransport("");
    });
  }, []);

  const onLoadBounds = (map) => {
    if (!map) return;
    const bounds = new window.google.maps.LatLngBounds();
    positions.forEach((child) => {
      bounds.extend(new window.google.maps.LatLng(child.lat, child.lng));
    });
    map.fitBounds(bounds);
    setMap(map);
  };

  const defaultMapOptions = {
    fullscreenControl: true,
  };

  const onUnmount = React.useCallback(() => {
    setMap(null);
  }, []);

  const containerStyle = {
    width: "100%",
    height: "50vh",
  };

  const options = {
    fillColor: "lightblue",
    fillOpacity: 1,
    strokeColor: "blue",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
  };

  const handleTransportDate = (time) => {
    return timestampToDateYearAndTime(time._seconds, time._nanoseconds);
  };

  const adminGetAllActiveTransport = async (id) => {
    setLoading(true);
    try {
      const result = await service.adminShowAllAssignmentTransports(id);
      setLoading(false);
      log(result);
      if (result) {
        setLoading(false);
        switch (result.data.code) {
          case 200:
            if (id === "") {
              setTransports(result.data.transportList);
            } else {
              const list = [...transports, ...result.data.transportList];
              setTransports(list);
            }
            const positionsData = [];
            for (const trip of result.data.transportList) {
              positionsData.push(
                {
                  lat: trip.origin_geopoint._latitude,
                  lng: trip.origin_geopoint._longitude,
                  icon: origin,
                  zIndex: 9,
                },
                {
                  lat: trip.destination_geopoint._latitude,
                  lng: trip.destination_geopoint._longitude,
                  icon: destination,
                  zIndex: 9,
                }
              );
            }
            setPositions(prev => [...prev, ...positionsData]);

            if (result.data.cursor_transport_id) {
              setCursorTransportId(result.data.cursor_transport_id);
              setBtnHidden(false);
            } else {
              setCursorTransportId("");
              setBtnHidden(true);
            }

            return;
          case 401:
            toast.error(result.data.message);
            return props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
    }
    setLoading(false);
  };

  const adminCreateBundledTransports = async () => {
    setLoading(true);
    try {
      const result = await service.adminCreateBundledTransports(selectedIds);
      setLoading(false);
      log(result);
      if (result) {
        switch (result.data.code) {
          case 200:
            return props.history.push(
              "/home/bundleTransport/lockedBundleTransport",
              {
                transportListToBundle: result.data.transport_list,
              }
            );
          case 401:
            toast.error(result.data.message);
            return props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
    }
    setLoading(false);
  };

  const handleBearerType = (bearer) => {
    switch (bearer) {
      case "driving":
        return (
          <div className="bearer">
            <img src={drivingImage} alt="rider" />
          </div>
        );
      case "riding":
        return (
          <div className="bearer">
            <img src={ridingImage} alt="rider" />
          </div>
        );
      case "cycling":
        return (
          <div className="bearer">
            <img src={cyclingImage} alt="cycle" />
          </div>
        );
      case "walking":
        return (
          <div className="bearer">
            <img src={walkingImage} alt="walk" />
          </div>
        );
      default:
        return null;
    }
  };

  const handleSelectedRow = (transport) => {
    setSelectedIds((prev) => {
      let newSelected;
      let newColors = { ...selectedColors };

      if (prev.includes(transport.transport_id)) {
        newSelected = prev.filter((id) => id !== transport.transport_id);
        delete newColors[transport.transport_id];
      } else {
        newSelected = [...prev, transport.transport_id];
        const randomColor = `#${Math.floor(Math.random() * 16777215).toString(
          16
        )}`;
        newColors[transport.transport_id] = randomColor;
      }

      setSelectedColors(newColors);
      return newSelected;
    });
  };

  const loadGoogleMap = () => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={13}
        onLoad={onLoadBounds}
        onUnmount={onUnmount}
        defaultOptions={defaultMapOptions}
        options={{
          mapId: getMapIdBasedonEnvironment(),
        }}
      >
        {positions.map((marker) => (
          <Marker
            position={marker}
            key={marker.lat + marker.lng + Math.random()}
            icon={{
              url: marker.icon,
            }}
          />
        ))}

        {transports.map((trip, idx) => {
          const isSelected = selectedIds.includes(trip.transport_id);
          const color = selectedColors[trip.transport_id] || "blue";

          const polylineOptions = {
            ...options,
            strokeColor: color,
            strokeWeight: isSelected ? 4 : 2,
            zIndex: isSelected ? 999 : 1,
          };

          const path = decodePolyline(trip.overview_polyline);
          const selectionIndex = selectedIds.indexOf(trip.transport_id) + 1;
          const showLabel = isSelected && selectionIndex > 0;
          const midpoint = showLabel ? path[Math.floor(path.length / 2)] : null;

          return (
            <React.Fragment key={`polyline-${idx}`}>
              <Polyline path={path} options={polylineOptions} />
              {showLabel && midpoint && (
                <Marker
                  position={midpoint}
                  label={{
                    text: `${selectionIndex}`,
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                  icon={{
                    path: window.google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: color,
                    fillOpacity: 1,
                    strokeWeight: 1,
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </GoogleMap>
    );
  };

  const renderSpinner = () => (isLoading ? <Spinner /> : null);

  return (
    <div className="show-all-list data-server-list bundle-transport">
      <ToastContainer />
      {renderSpinner()}

      <h6>
        Found {transports.length} {transports.length > 1 ? "results" : "result"}
      </h6>

      {positions.length > 0 && <div className="map">{loadGoogleMap()}</div>}

      {transports.length > 0 && (
        <>
          <table className="table" style={{ marginTop: 50 }}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Order No.</th>
                <th>Customer Name</th>
                <th>Origin Address</th>
                <th>Destination Address</th>
                <th>Distance</th>
                <th>Duration</th>
                <th>Paid by Customer</th>
                <th>Payable to Bearer</th>
                <th>Parcel Type</th>
                <th>Bearer Type</th>
                <th>(More Details)</th>
              </tr>
            </thead>
            <tbody>
              {transports.map((transport) => (
                <tr
                  key={transport.transport_id}
                  onClick={() => handleSelectedRow(transport)}
                  style={{
                    backgroundColor: selectedIds.includes(
                      transport.transport_id
                    )
                      ? "#dee2e6"
                      : "transparent",
                    cursor: "pointer",
                  }}
                >
                  <td>{handleTransportDate(transport.time)}</td>
                  <td>{transport.order_number}</td>
                  <td>
                    {(transport.customer_given_name || "") +
                      " " +
                      (transport.customer_last_name || "")}
                  </td>
                  <td>{transport.origin_address}</td>
                  <td>{transport.destination_address}</td>
                  <td>{transport.transport_length}</td>
                  <td>{transport.transport_time}</td>
                  <td>{"A$ " + transport.transport_receivable_price}</td>
                  <td>{"A$ " + transport.original_payable_to_rider}</td>
                  <td>
                    <BundleParcelImageComponents path={transport.parcel_img_url} />
                  </td>
                  <td>{handleBearerType(transport.bearer_type)}</td>
                  <td>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        props.history.push("/home/transportSingle", {
                          transportId: transport.transport_id,
                        });
                      }}
                      className="single-view"
                    >
                      view
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="load-more">
            <ul style={{ margin: 0 }}>
              {!isHidden && (
                <li>
                  <button
                    onClick={() =>
                      adminGetAllActiveTransport(cursorTransportId)
                    }
                  >
                    Load More
                  </button>
                </li>
              )}
              {selectedIds.length > 0 && (
                <li>
                  <button onClick={() => adminCreateBundledTransports()}>
                    Lock & Continue
                  </button>
                </li>
              )}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}

export default BundleTransport;
